import { Locale } from 'react-js-cron';

const BRAZIL_LOCALE: Locale = {
	everyText: 'Todo',
	emptyMonths: 'mês',
	emptyMonthDays: 'todo dia do mês',
	emptyMonthDaysShort: 'dia do mês',
	emptyWeekDays: 'todo dia da semana',
	emptyWeekDaysShort: 'dia da semana',
	emptyHours: 'toda hora',
	emptyMinutes: 'todo minuto',
	emptyMinutesForHourPeriod: 'todo',
	yearOption: 'ano',
	monthOption: 'mês',
	weekOption: 'semana',
	dayOption: 'dia',
	hourOption: 'hora',
	minuteOption: 'minuto',
	rebootOption: 'Reboot',
	prefixPeriod: 'Todo(a)',
	prefixMonths: 'em',
	prefixMonthDays: 'em',
	prefixWeekDays: 'em',
	prefixWeekDaysForMonthAndYearPeriod: 'e',
	prefixHours: 'às',
	prefixMinutesForHourPeriod: 'em',
	suffixMinutesForHourPeriod: 'minuto(s)',
	errorInvalidCron: 'Expressão inválida',
	clearButtonText: 'Limpar',
	weekDays: [
		'Domingo',
		'Segunda',
		'Terça',
		'Quarta',
		'Quinta',
		'Sexta',
		'Sábado',
	],
	months: [
		'Janeiro',
		'Fevereiro',
		'Março',
		'Abril',
		'Maio',
		'Junho',
		'Julho',
		'Agosto',
		'Setembro',
		'Outubro',
		'Novembro',
		'Dezembro',
	],
	altWeekDays: [
		'Dom',
		'Seg',
		'Ter',
		'Qua',
		'Qui',
		'Sex',
		'Sáb',
	],
	altMonths: [
		'Jan',
		'Fev',
		'Mar',
		'Abr',
		'Mai',
		'Jun',
		'Jul',
		'Ago',
		'Set',
		'Out',
		'Nov',
		'Dez',
	],
};

export default BRAZIL_LOCALE;